<script setup lang="ts">
import { usePage } from "@inertiajs/vue3";
import { computed } from "vue";
import { PageProps } from "@/Types";
import {BlockResource, BlockTypeEnum} from "@/Types/generated.d";
import MainImage from "@/Pages/Frontend/Media/Partials/MainImage.vue";
import Slider from "@/Components/Frontend/Elements/Slider.vue";
import {useSanitize} from "@/Composables/Shared/useSanitize";
// --- Props
// --- Data
const sanitize = useSanitize();
// --- Computed
const initialPageProps = computed(() => usePage<PageProps>().props);
const blocks = computed<BlockResource[]>(() => {
    return initialPageProps.value.blocks?.filter((block) => {
        return block.type === BlockTypeEnum.REINSURANCE;
    }) ?? []
});
// --- Methods
// --- Watch
// --- Provide
</script>
<template>
    <div class="container relative" v-if="blocks.length">
        <Slider
            :slides="blocks"
            :slides-per-view="1"
            :loop="true"
            :breakpoints="{ '1024': { slidesPerView: blocks.length, loop: false, spaceBetween: 20 } }"
            :slider-class="``"
            :slider-name="`reinsurance`"
            class="reinsurance"
        >
            <template #slideContent="{ item }">
                <MainImage
                    v-if="item.medias?.length"
                    :medias="item.medias"
                    :alt="item.title"
                    loading="lazy"
                    format="original"
                />
                <div v-else class="img-placeholder"></div>
                <p class="reinsurance-slide__title">{{ item.title }}</p>
                <div class="reinsurance-slide__text prose" v-html="sanitize.html(item.content)"></div>
            </template>
        </Slider>
    </div>
</template>
<style lang="postcss" scoped>
.reinsurance-slide__title {
    @apply mb-1 font-normal uppercase;
}
.reinsurance-slide__text {
    @apply max-w-[200px] text-2xs;
}
</style>
<style lang="postcss">
.reinsurance {
    @apply relative py-16;

    @screen lg {
        @apply flex justify-around;
    }
}
.reinsurance swiper-slide {
    @apply flex flex-col items-center text-center;

    img,
    .img-placeholder {
        @apply mb-6 inline-block h-[45px];
    }
}
</style>
